import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    margin: theme.spacing(4),
    padding: theme.spacing(6, 3),
    flexGrow: 1,

    '& > .content': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100%',
      textAlign: 'center',
    },

    '& .locked': {
      '&-title': {
        marginBottom: theme.spacing(3),
        color: theme.palette.primary.main,

        '&-icon': {
          fontSize: theme.spacing(4),
        },
      },
      '&-description': {
        color: theme.palette.text.secondary,
        maxWidth: 600,
      },
    },
  },
}));

export default styles;
